import { z } from "src/lib";
import { OperacionLCSLHPTIFields, OperacionLCSLHPTITablaValorFields } from "./fields";
import { schemaEntityWithId } from "src/types";

export const schemaOperacionLCSLHPTITablaValorInsert = z.object({
    [OperacionLCSLHPTITablaValorFields.IdOperacionLCSLHPTI]: z.number().nullable().optional(),
    [OperacionLCSLHPTITablaValorFields.CodInstrumento]: z.number(),
    [OperacionLCSLHPTITablaValorFields.CodOperacionTipo]: z.number(),
    [OperacionLCSLHPTITablaValorFields.DescInstrumento]: z.string(),
    [OperacionLCSLHPTITablaValorFields.Orden]: z.number(),
    [OperacionLCSLHPTITablaValorFields.Valor]: z.string({ 
            invalid_type_error: 'El valor es requerido',
            required_error: 'El valor es requerido'
        }).nullable(),
});
export type OperacionLCSLHPTITablaValorInsert = z.infer<typeof schemaOperacionLCSLHPTITablaValorInsert>;

export const schemaOperacionLCSLHPTIInsert = z.object({
    [OperacionLCSLHPTIFields.CodPais]: z.number(),
    [OperacionLCSLHPTIFields.CodUnidadNegocio]: z.number().nullable(),
    [OperacionLCSLHPTIFields.CodSectorComercial]: z.number(),
    [OperacionLCSLHPTIFields.FechaSolicitud]: z.date(),
    [OperacionLCSLHPTIFields.FechaVencimiento]: z.date(),
    [OperacionLCSLHPTIFields.Observaciones]: z.string().nullable().optional(),
    [OperacionLCSLHPTIFields.TablaValores]: z.array(schemaOperacionLCSLHPTITablaValorInsert),
});
export type OperacionLCSLHPTIInsert = z.infer<typeof schemaOperacionLCSLHPTIInsert>;

export const schemaOperacionLCSLHPTITablaValorUpdate = z.object({
    [OperacionLCSLHPTITablaValorFields.Valor]: z.string({
        required_error: 'El valor es requerido.',
    }),
});
export type OperacionLCSLHPTITablaValorUpdate = z.infer<typeof schemaOperacionLCSLHPTITablaValorUpdate>;

export const schemaOperacionLCSLHPTITablaValorVista = z.object({
    [OperacionLCSLHPTITablaValorFields.IdOperacionLCSLHPTI]: z.number(),
    [OperacionLCSLHPTITablaValorFields.CodInstrumento]: z.number(),
    [OperacionLCSLHPTITablaValorFields.DescInstrumento]: z.string(),
    [OperacionLCSLHPTITablaValorFields.CodOperacionTipo]: z.number(),
    [OperacionLCSLHPTITablaValorFields.DescOperacionTipo]: z.string(),
    [OperacionLCSLHPTITablaValorFields.Valor]: z.string(),
    [OperacionLCSLHPTITablaValorFields.Orden]: z.number(),
    [OperacionLCSLHPTITablaValorFields.PermiteEditarInstrumento]: z.boolean(),
    [OperacionLCSLHPTITablaValorFields.Agrupacion]: z.string(),
    [OperacionLCSLHPTITablaValorFields.TipoSelector]: z.enum([
        'concentracion', 
        'limite_perdida', 
        'limite_holding', 
        'limite_credito'
    ])
}).merge(schemaEntityWithId);
export type OperacionLCSLHPTITablaValorVista = z.infer<typeof schemaOperacionLCSLHPTITablaValorVista>;

export const schemaOperacionLCSLHPTITablaValorVistaInicial = z.object({
    [OperacionLCSLHPTITablaValorFields.CodInstrumento]: z.number(),
    [OperacionLCSLHPTITablaValorFields.DescInstrumento]: z.string(),
    [OperacionLCSLHPTITablaValorFields.CodOperacionTipo]: z.number(),
    [OperacionLCSLHPTITablaValorFields.DescOperacionTipo]: z.string(),
    [OperacionLCSLHPTITablaValorFields.Valor]: z.string().nullable(),
    [OperacionLCSLHPTITablaValorFields.Orden]: z.number().nullable(),
    [OperacionLCSLHPTITablaValorFields.PermiteEditarInstrumento]: z.boolean(),
    [OperacionLCSLHPTITablaValorFields.Agrupacion]: z.string(),
    [OperacionLCSLHPTITablaValorFields.TipoSelector]: z.enum([
        'concentracion', 
        'limite_perdida', 
        'limite_holding', 
        'limite_credito'
    ])
});
export type OperacionLCSLHPTITablaValorVistaInicial = z.infer<typeof schemaOperacionLCSLHPTITablaValorVistaInicial>;